<template lang="html">
  <div class="main-container">
    <breadcrumb 
    :list="breadcrumbList"/>
    <tl-header class="title margin-top-3" type="h3">Reset Password</tl-header>
    <br>
    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
    <search-dropdown label="Select Employee" v-model="searchText" :employeeData="customEmpList" @getList="searchDataList" @empselected="(emp)=>selectedEmp(emp)"/>
    <br>
    <selected-employee-card v-if="showSelectedEmployee" @click="closeCard" :empPhotoUrl="empPhotoUrl">
      <template v-slot:empDetails>
        <span class="input-label">
          <b>{{empName}}</b>
        </span>
        <span class="input-label">{{empId}}</span>
        <span class="input-label">{{empMail}}</span>
        <span class="input-label">{{joiningDate}}</span>
        <span class="input-label">Last Login : {{lastLogin}}</span>
        <div class="bottom-buttons">
          <button class="export-button" @click="sendPassword">
            <span> Send </span>
          </button>
          <!-- <button class="export-button" @click="viewPassword">
            <span> View </span>
          </button> -->
        </div>
      </template>
    </selected-employee-card>

    <div class="new-password" v-show="showPassword">
      <span class="label">
        <span class="password-text">New Password is :</span> {{ newPassword }} </span>
      <a @click="copy"> Copy </a>
    </div>

    <div class="modal" v-show="showSendPopup">
      <div class="modal-content">

        <p class="header header3 forgpass">
          <span class="text">Password Generated</span>
        </p>
        <span class="label">We have sent the password on {{empMail}}.</span>
        <br>

        <div class="popup-btns">
          <btn text="Ok" type="primary" @click="ok" />
        </div>
      </div>
    </div>

    <bottom-action-container>
      <template slot="end">
          <btn-grp>
            <btn text="Back" type="secondary" @click="routeToSubStep" />
          </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";

export default {
  name: "resetPassword",
  components: {
    SearchDropdown,
    SelectedEmployeeCard
  },

  data() {
    return {
      searchText: "",
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },
        {
          name: "Reset Password",
          url: ""
        }
      ],
      selectedEmployee: {},
      toast: false,
      errmsg: "",
      showSuccessMsg: false,
      empName: "",
      empId: "",
      empMail: "",
      empPhotoUrl: null,
      joiningDate: "",
      lastLogin: "",
      newPassword: "",
      showSelectedEmployee: false,
      showPassword: false,
      showSendPopup: false,
      customEmpList: []
    };
  },
  computed: {
    ...mapGetters({
      orgid: "onboard/organization/orgid",
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  activated: function() {
    this.refresh();
  },

  mounted() {
    this.refresh();
  },

  methods: {
    ...mapActions({
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_fetchAllEmployees_by_name: "globalapi/globalemployees/fetchByName",
      reset_employee_password:
        "dashboard/organisation/utilities/resetPassword/create",
      act_fetch_UserList_by_name:
        "dashboard/organisation/utilities/resetPassword/fetchEmpByName",
      act_fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName"
    }),

    refresh(){
      try {
        this.selectedEmployee = null;
        this.showSelectedEmployee = false;
        this.empName = "";
        this.empId = null;
        this.empMail = "";
        this.empPhotoUrl = null;
        this.joiningDate = "";
        this.lastLogin = "";
        this.toast = false;
        this.errmsg = "";
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },

    backfrompopup() {
      this.showSuccessMsg = false;
    },

    submit() {
      this.showSuccessMsg = true;
    },
    closeCard() {
      this.showSelectedEmployee = false;
    },

    async searchDataList(text) {
      try {
        /** Get Employee List by Admin for All Orgs */
        /*//let res = await this.act_fetch_UserList_by_name(text);*/
        //let res = await this.act_fetchAllEmployees_by_name(text);

        let res = await this.act_fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: text
        });
        if (res.status) {
          this.customEmpList = res.data.payload;
          this.customEmpList = [...this.customEmpList];
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    selectedEmp(emp) {
      try {
        this.selectedEmployee = emp;
        this.showSelectedEmployee = true;
        this.empName = emp.name;
        this.empId = emp.code;
        this.empMail = emp.email;
        this.joiningDate = emp.joiningDate;
        this.lastLogin = emp.lastLogin;
        this.empPhotoUrl = emp.photo_url ? emp.photo_url : null;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },
    sendPassword() {
      this.resetPassword();
    },

    async resetPassword() {
      try {
        let obj = {
          identity: this.selectedEmployee.email
        };
        let res = await this.reset_employee_password(obj);
        if (res.status == 200 || res.status == 201) {
          this.showSendPopup = true;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    viewPassword() {
      this.showPassword = true;
      this.newPassword = "123456$";
    },
    copy() {},
    ok() {
      try {
        this.showSendPopup = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        });
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-top-3 {
  margin-top: 3%;
}

.header.header3 {
  padding-bottom: 0px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 220px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .popup-btns {
    margin-top: 5%;
    display: flex;
    justify-content: center; // a {
    //   margin-top: 4%;
    //   margin-left: 32%;
    // }
  }
}

.new-password {
  margin-top: 20px;
  height: 40px;
  width: 370px;
  padding: 10px;
  text-align: center;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;

  a {
    cursor: pointer;
    font-family: Montserrat;
    font-size: 13px;
    text-decoration: none;
    margin-left: 20px;
    color: #5d409f;
  }
  .password-text {
    color: #646464;
  }
}

.forgpass {
  padding: 0px;
  .text {
    font-size: 20px;
  }
}

.bottom-buttons {
  display: flex; // justify-content: center;
  padding-bottom: 10px;
  button {
    margin-right: 10px;
  }
}
</style>